// extracted by mini-css-extract-plugin
module.exports = {"holder":"styles_holder__P_UQl","input":"styles_input__ZFAM4"};